import { render } from "./IsabelleConnection.vue?vue&type=template&id=acfed8a8"
import script from "./IsabelleConnection.vue?vue&type=script&lang=js"
export * from "./IsabelleConnection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__